import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { alpha, type SxProps, type Theme } from "@mui/material/styles";
import type { ReactNode } from "react";
import { InfoOutlinedIcon } from "@/shared/ui/console-icons";
import { ConsoleSurface, SectionHeading } from "@/shared/ui";

interface ChartCardProps {
  title: string;
  icon?: ReactNode;
  action?: ReactNode;
  footerNote?: ReactNode;
  children: ReactNode;
  contentSx?: SxProps<Theme>;
}

export function ChartCard({
  title,
  icon,
  action,
  footerNote,
  children,
  contentSx,
}: ChartCardProps) {
  return (
    <ConsoleSurface
      component="section"
      sx={{ display: "flex", flexDirection: "column", overflow: "hidden", height: "100%" }}
    >
      <Box
        sx={[
          {
            p: 2,
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            flex: "1 1 auto",
            minHeight: 0,
          },
          ...(Array.isArray(contentSx) ? contentSx : [contentSx]),
        ]}
      >
        <SectionHeading icon={icon} component="h2" action={action}>
          {title}
        </SectionHeading>
        {children}
      </Box>

      {footerNote != null && (
        <Box
          sx={(theme) => ({
            display: "flex",
            alignItems: "flex-start",
            gap: 0.75,
            px: 2,
            py: 1,
            backgroundColor: alpha(theme.palette.common.black, 0.25),
            borderTop: `1px solid ${alpha(theme.palette.common.white, 0.1)}`,
          })}
        >
          <InfoOutlinedIcon
            aria-hidden="true"
            sx={{ fontSize: "0.875rem", color: "info.main", mt: 0.1, flexShrink: 0 }}
          />
          <Typography variant="caption" color="text.secondary">
            {footerNote}
          </Typography>
        </Box>
      )}
    </ConsoleSurface>
  );
}
